// vaultPaths.js -- build path: /srv/ratkeeper/app/config.py  (internal only)